import { createPost, deletePostById, readPostById, readPosts, replacePost } from 'api/post';
import { CreatePostRequest, UpdatePostRequest } from 'api/post/types';
import isNull from 'lodash/isNull';
import { PaginateParamsRequest } from 'types/common';
import { PostFormData } from 'types/post';

export const createNewPost = (data: PostFormData, appointmentId: string, authorId: string) => {
    const requestData: CreatePostRequest = {
        ...data,
        appointmentId,
        authorId,
    };
    return createPost(requestData).then((res) => res.data);
};

export const updatePost = ({ message, attachments }: PostFormData, postId: string) => {
    const requestData: UpdatePostRequest = {
        message: message || null,
        attachments: attachments.length ? attachments : null,
    };
    return replacePost(requestData, postId).then((res) => res.data);
};

export const getPosts = (params: PaginateParamsRequest, appointmentId: string) => {
    const requestParams = {
        ...params,
        appointmentId,
    };
    return readPosts(requestParams).then((res) => res.data);
};

export const getPostDetails = (id: string) => readPostById({ id }).then(({ data }) => data);

export const getPostFormData = (id: string) =>
    readPostById({ id }).then(({ data }) => {
        const { message, attachments } = data;
        return {
            message: isNull(message) || '',
            attachments: isNull(attachments) ? [] : attachments,
        };
    });

export const deletePost = (id: string) => {
    return deletePostById({ id }).then((res) => res.data);
};
